var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "sign-in-container" },
      [
        _c("form-logo", { attrs: { logoUrl: _vm.logoUrl } }),
        _vm._v(" "),
        _c("login-fail", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasError,
              expression: "hasError"
            }
          ]
        }),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "mds-form mds-form--large-layout",
            attrs: { name: "loginForm" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.validateInput($event)
              }
            }
          },
          [
            _c(
              "fieldset",
              { staticClass: "mds-form__fieldset" },
              [
                _c("legend", { staticClass: "mds-form__legend" }, [
                  _vm._v("Login Information fields")
                ]),
                _vm._v(" "),
                _vm._l(_vm.formInputs, function(group) {
                  return _c("input-field", {
                    key: group.id,
                    attrs: {
                      id: group.id,
                      error: group.error,
                      title: group.title,
                      type: group.type,
                      described: group.described,
                      v: _vm.$v[group.id]
                    },
                    on: { handleShowPassword: _vm.handleShowPassword },
                    model: {
                      value: _vm.$data[group.id],
                      callback: function($$v) {
                        _vm.$set(_vm.$data, group.id, $$v)
                      },
                      expression: "$data[group.id]"
                    }
                  })
                }),
                _vm._v(" "),
                _c("login-controls", {
                  attrs: {
                    "disable-login-btn": !_vm.disableLoginBtn,
                    "user-name": this.$mwc.settings.useEmail
                      ? _vm.emailInput
                      : _vm.userNameInput,
                    password: _vm.passwordInput,
                    "reset-password-url": _vm.resetPasswordUrl
                  },
                  on: { handleFailedInputs: _vm.handleFailedInputs }
                })
              ],
              2
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }